import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OrderType } from "../services/order/order.type";
import { CartItem } from "../services/pos/pos.type";

interface PosState {
  cart: CartItem[];
  orderType: OrderType;
  selectedTable: string | null;
  selectedMenu: string | null;
}

const initialState: PosState = {
  cart: [],
  orderType: "dine_in",
  selectedTable: null,
  selectedMenu: null,
};

export const posSlice = createSlice({
  name: "pos",
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<CartItem>) => {
      const existingIndex = state.cart.findIndex(
        (item) =>
          item.menuItemId === action.payload.menuItemId &&
          item.menuComboId === action.payload.menuComboId &&
          item.dailyDishId === action.payload.dailyDishId &&
          item.additionalDemands === action.payload.additionalDemands &&
          JSON.stringify(item.selectedOptionValues) ===
            JSON.stringify(action.payload.selectedOptionValues)
      );

      if (existingIndex !== -1) {
        state.cart[existingIndex].quantity += action.payload.quantity;
      } else {
        state.cart.push(action.payload);
      }
    },

    removeFromCart: (state, action: PayloadAction<number>) => {
      state.cart.splice(action.payload, 1);
    },

    updateCartItemQuantity: (
      state,
      action: PayloadAction<{ index: number; quantity: number }>
    ) => {
      const { index, quantity } = action.payload;
      if (index >= 0 && index < state.cart.length) {
        if (quantity <= 0) {
          state.cart.splice(index, 1);
        } else {
          state.cart[index].quantity = quantity;
        }
      }
    },

    updateCartItemDemands: (
      state,
      action: PayloadAction<{ index: number; additionalDemands: string }>
    ) => {
      const { index, additionalDemands } = action.payload;
      if (index >= 0 && index < state.cart.length) {
        state.cart[index].additionalDemands = additionalDemands;
      }
    },

    clearCart: (state) => {
      state.cart = [];
    },

    setOrderType: (state, action: PayloadAction<OrderType>) => {
      state.orderType = action.payload;
    },

    setSelectedTable: (state, action: PayloadAction<string | null>) => {
      state.selectedTable = action.payload;
    },

    setSelectedMenu: (state, action: PayloadAction<string | null>) => {
      state.selectedMenu = action.payload;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  updateCartItemQuantity,
  updateCartItemDemands,
  clearCart,
  setOrderType,
  setSelectedTable,
  setSelectedMenu,
} = posSlice.actions;

export default posSlice.reducer;
